// const appConfig = { target: "marginx", session: 39777 };

const appConfig = {
  target: "marginx",
  session: 39777,
  methods: ["marginx_signDirect", "marginx_signAmino", "marginx_getAccounts"],
  // methods: [
  //   "functionx_signDirect",
  //   "functionx_signAmino",
  //   "functionx_getAccounts",
  // ],
};

export const marginxSuggestChainsBase = {
  appConfig,
  suggest: {
    bip44: {
      coinType: 60,
    },
    bech32Config: {
      bech32PrefixAccAddr: "mx",
      bech32PrefixAccPub: "mxpub",
      bech32PrefixValAddr: "mxvaloper",
      bech32PrefixValPub: "mxvaloperpub",
      bech32PrefixConsAddr: "mxvalcons",
      bech32PrefixConsPub: "mxvalconspub",
    },

    currencies: [
      {
        coinDenom: "cusd",
        coinMinimalDenom: "cusd",
        coinDecimals: 6,
        coinGeckoId: "tether",
      },
    ],
    feeCurrencies: [
      {
        coinDenom: "cusd",
        coinMinimalDenom: "cusd",
        coinDecimals: 6,
        coinGeckoId: "tether",
        gasPriceStep: {
          low: 0.000000005,
          average: 0.000000005,
          high: 0.000000005,
        },
      },
      // {
      //   coinDenom: "FX",
      //   coinMinimalDenom: "FX",
      //   coinDecimals: 6,
      //   coinGeckoId: "fx-coin",
      //   gasPriceStep: {
      //     low: 0.026,
      //     average: 0.026,
      //     high: 0.0324,
      //   },
      // },
    ],
    stakeCurrency: {
      coinDenom: "cusd",
      coinMinimalDenom: "cusd",
      coinDecimals: 6,
      coinGeckoId: "tether",
    },
    // stakeCurrency: {
    //   coinDenom: "FX",
    //   coinMinimalDenom: "FX",
    //   coinDecimals: 6,
    //   coinGeckoId: "fx-coin",
    // },
    features: ["eth-address-gen", "eth-key-sign", "ibc-transfer"],
    beta: true,
  },
};
export const marginxSuggestChains = {
  chainId: "MarginX-Testnet-BTC",
  chainName: "MarginX BTC(testnet)",
  rpc: "https://testnet-btc-json.marginx.io:26657",
  rest: "https://testnet-btc-rest.marginx.io:1317",
  // chainId: "mx-btc",
  // chainName: "MarginX BTC(test)",
  // rpc: "http://192.168.20.214:26657",
  // rest: "http://192.168.20.214:1317",
  ...marginxSuggestChainsBase,
};
